
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB1-OiISV0Av1IFW3kGMXd7ZY-frxSlAY8",
  authDomain: "code-for-golf-shot-camera.firebaseapp.com",
  databaseURL: "https://code-for-golf-shot-camera.firebaseio.com",
  projectId: "code-for-golf-shot-camera",
  storageBucket: "code-for-golf-shot-camera.appspot.com",
  messagingSenderId: "523347686574",
  appId: "1:523347686574:web:a3438b3baf87752b"
};

export {
    FIREBASE_CONFIG,
};
